import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "payment-section mt-2" }
const _hoisted_2 = { class: "payment-card" }
const _hoisted_3 = { class: "payment-row-top" }
const _hoisted_4 = { class: "payment-amount" }
const _hoisted_5 = {
  key: 0,
  class: "payment-meta"
}
const _hoisted_6 = { class: "payment-method text-capitalize" }
const _hoisted_7 = { class: "payment-time" }
const _hoisted_8 = { class: "payment-breakdown" }
const _hoisted_9 = {
  key: 0,
  class: "breakdown-row"
}
const _hoisted_10 = {
  key: 1,
  class: "breakdown-row"
}
const _hoisted_11 = { class: "breakdown-row breakdown-total" }
const _hoisted_12 = {
  key: 0,
  class: "payment-details"
}
const _hoisted_13 = { class: "payment-row" }
const _hoisted_14 = { class: "payment-icon" }
const _hoisted_15 = { class: "payment-value" }
const _hoisted_16 = { class: "payment-row" }
const _hoisted_17 = { class: "payment-icon" }
const _hoisted_18 = { class: "payment-value" }
const _hoisted_19 = { class: "payment-row" }
const _hoisted_20 = { class: "payment-icon" }
const _hoisted_21 = { class: "payment-value" }
const _hoisted_22 = { class: "payment-breakdown" }
const _hoisted_23 = { class: "breakdown-row" }
const _hoisted_24 = { class: "breakdown-row" }
const _hoisted_25 = { class: "breakdown-row breakdown-total" }

import { computed, ref } from "vue";
import { formatCurrency, formatDate } from "@/shared/utils/utils";

type PaymentInfo = {
  id: number | string;
  payment_code: string;
  amount: string | number;
  gateway: string;
  payment_type: string;
  card_last4: string | null;
  cardholder_name: string | null;
  transaction_id: string | null;
  ref_no: string | null;
  created_at: string;
} | null;

type TotalInfo = {
  is_paid: number | boolean;
  sub_total: string | number | null;
  tax_amount: string | number | null;
  total_amount: string | number | null;
} | null;


export default /*@__PURE__*/_defineComponent({
  __name: 'AppointmentPaymentSummary',
  props: {
    appointment: {}
  },
  setup(__props: any) {

const props = __props;

const showDetails = ref(false);

function asNumber(value: unknown): number | null {
  if (typeof value === "number" && !Number.isNaN(value)) return value;
  if (typeof value === "string" && value.trim() !== "") {
    const n = Number(value);
    return Number.isNaN(n) ? null : n;
  }
  return null;
}

const isPaid = computed(() => Boolean(props.appointment.total_info?.is_paid));

const paymentCode = computed(() => props.appointment.payment_info?.payment_code || "-");
const paymentCreatedAt = computed(() => props.appointment.payment_info?.created_at || "");
const paymentTypeDisplay = computed(() => props.appointment.payment_info?.payment_type || "-");

const paymentCardLast4Display = computed(() => {
  const last4 = props.appointment.payment_info?.card_last4;
  return last4 ? `•••• ${last4}` : "-";
});

const paidAmountFormatted = computed(() => {
  const n = asNumber(props.appointment.payment_info?.amount);
  return n === null ? "-" : formatCurrency(n);
});

const subTotalFormatted = computed(() => {
  const n = asNumber(props.appointment.total_info?.sub_total);
  return n === null ? "-" : formatCurrency(n);
});

const taxFormatted = computed(() => {
  const n = asNumber(props.appointment.total_info?.tax_amount);
  return n === null ? "-" : formatCurrency(n);
});

const totalAmountFormatted = computed(() => {
  const n = asNumber(props.appointment.total_info?.total_amount);
  return n === null ? "-" : formatCurrency(n);
});

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "px-2" }, [
      _createElementVNode("p", { class: "payment-section-title" }, "Payment Summary")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(totalAmountFormatted.value), 1),
          _createVNode(_component_v_chip, {
            color: isPaid.value ? 'success' : 'error',
            size: "small",
            label: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(isPaid.value ? "Paid" : "Unpaid"), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        (paymentCreatedAt.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(paymentTypeDisplay.value) + " " + _toDisplayString(paymentCardLast4Display.value), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(paymentCreatedAt.value ? _unref(formatDate)(paymentCreatedAt.value) : "-"), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (subTotalFormatted.value !== '-')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[0] || (_cache[0] = _createElementVNode("span", null, "Subtotal", -1)),
              _createElementVNode("span", null, _toDisplayString(subTotalFormatted.value), 1)
            ]))
          : _createCommentVNode("", true),
        (taxFormatted.value !== '-')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "Tax", -1)),
              _createElementVNode("span", null, _toDisplayString(taxFormatted.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Total", -1)),
          _createElementVNode("span", null, _toDisplayString(totalAmountFormatted.value), 1)
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "collapse" }, {
      default: _withCtx(() => [
        (showDetails.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-receipt-text-outline", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("p", { class: "payment-label" }, "Payment Code", -1)),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(paymentCode.value), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("mdi-credit-card-outline", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  _cache[6] || (_cache[6] = _createElementVNode("p", { class: "payment-label" }, "Payment Method", -1)),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(paymentCardLast4Display.value), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("mdi-cash-multiple", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("p", { class: "payment-label" }, "Paid Amount", -1)),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(paidAmountFormatted.value), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", null, "Subtotal", -1)),
                  _createElementVNode("span", null, _toDisplayString(subTotalFormatted.value), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[10] || (_cache[10] = _createElementVNode("span", null, "Tax", -1)),
                  _createElementVNode("span", null, _toDisplayString(taxFormatted.value), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", null, "Total", -1)),
                  _createElementVNode("span", null, _toDisplayString(totalAmountFormatted.value), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})